<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<div class="_idGenObjectLayout-1">
<div id="_idContainer002">
<img alt="" class="_idGenObjectAttribute-3" src="image/T_nk_lidt_over.jpg"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SustainableBadass-3.vue?3cc95d1a